import { AnalyticsEvent } from '../../../../analytics/events/analytics.event'

export class ClickEvent extends AnalyticsEvent {

  constructor (eventCategory = '', eventAction = '', eventLabel = '', filter?: string | null) {
    super('click', eventCategory, eventAction, eventLabel)
    if (!!filter) {
      const instance = this as any
      instance['TopNavi-Filter'] = filter
    }
  }
}
